module.exports = function (facets) {
  var key;
  var value;
  var output = {};

  function _modelToFacet(model) {
    if (!!model.value) {
      if (Object.prototype.toString.call(model.value) === "[object Array]") {
        model.value.forEach(function (valueItem, index) {
          if (valueItem) {
            // console.log("Value item", valueItem);
            output[model.id + "[" + index + "]"] = valueItem;
          }
        });
      } else {
        output[model.id] = model.value;
      }
    }
  }

  if (Object.prototype.toString.call(facets) === "[object Object]") {
    for (key in facets) {
      if (facets.hasOwnProperty(key)) {
        value = facets[key];
        value.model.forEach(_modelToFacet);
      }
    }
  }

  return output;
};
